import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { jsx as ___EmotionJSX } from "@emotion/core";
import React from 'react';
import { useAuth } from './useAuth';
export var AuthTransactionContext = React.createContext(undefined);
export var AuthTransactionProvider = function AuthTransactionProvider(_ref) {
  var children = _ref.children;

  var _React$useState = React.useState(undefined),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      currentTransaction = _React$useState2[0],
      setCurrentTransaction = _React$useState2[1];

  var _useAuth = useAuth(),
      authApi = _useAuth.authApi;

  return ___EmotionJSX(AuthTransactionContext.Provider, {
    value: {
      currentTransaction: currentTransaction,
      beginTransaction: function () {
        var _beginTransaction = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee(recoveryToken) {
          var transaction;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return authApi.verifyRecoveryToken(recoveryToken);

                case 2:
                  transaction = _context.sent;
                  setCurrentTransaction(transaction);
                  return _context.abrupt("return", transaction);

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function beginTransaction(_x) {
          return _beginTransaction.apply(this, arguments);
        }

        return beginTransaction;
      }()
    }
  }, children);
};
export var useAuthTransaction = function useAuthTransaction() {
  var context = React.useContext(AuthTransactionContext);

  if (!context) {
    throw new Error('useAuthTransaction can only be used inside an AuthTransactionProvider with a value');
  }

  var currentTransaction = context.currentTransaction,
      beginTransaction = context.beginTransaction;
  return {
    currentTransaction: currentTransaction,
    beginTransaction: beginTransaction
  };
};